<template>
  <div class="error-page">
    <div class="main-wrapper">
      <div class="error-box">
        <h1>404</h1>
        <h3 class="h2 mb-3">Oops! Page not found!</h3>
        <p class="h4 font-weight-normal">The page you requested was not found.</p>
        <router-link to="/app/dashboard" class="btn btn-primary">
          Back to Dashboard
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404Page'
}
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.error-box {
  text-align: center;
  padding: 40px;
}

.error-box h1 {
  font-size: 120px;
  font-weight: 700;
  color: #3d5ee1;
  margin-bottom: 20px;
}

.error-box h3 {
  font-weight: 600;
}

.error-box p {
  color: #6c757d;
  margin-bottom: 30px;
}
</style>
